<!-- Willy en plein écran (PC-09b) : la feuille prend tout l'écran sous la barre
     d'état ; l'en-tête du chat porte la fermeture, la carotte aussi. En bas, sous
     le pouce, les actions, juste au-dessus de la barre d'onglets qui reste posée
     sur la feuille. Pendant la saisie, actions et barre s'effacent : le champ
     se cale sur le clavier. La marge basse est déjà dans `barSpace` (celle de
     la barre), d'où `!pb-0` : pas de zone sûre comptée deux fois, ni d'écart
     de 48 px sous le champ au-dessus du clavier d'Android. -->
<vw-toast-popup variant="screen"
  [isOpen]="isOpen"
  [showClose]="false"
  ariaLabel="Willy"
  toastCustomClass="!pb-0"
  (close)="onClose()"
>
  <div class="flex h-full flex-col">
    <vw-ai-chatbot
      class="block min-h-0 flex-1"
      (closeRequested)="onClose()"
      (inputFocus)="onInputFocus()"
      (inputBlur)="onInputBlur()"
    ></vw-ai-chatbot>
    <div class="shrink-0 bg-vw-surface pt-2" [class.hidden]="inputIsFocus" [style.padding-bottom.px]="barSpace">
      <vw-modal-ai-actions-buttons
        (addPlant)="onAddPlant()"
        (showTasks)="onShowTasks()"
        (scan)="onScanBarcode()"
      >
      </vw-modal-ai-actions-buttons>
    </div>
  </div>
</vw-toast-popup>
